import { gsap, ScrollTrigger } from "@/composeables/gsap"

export const init = () => {
    const sliderSections = gsap.utils.toArray(".section-card-slider")

    sliderSections.forEach((section) => {
        const slides = section.querySelectorAll(
            ":scope .card-slider > .swiper > .swiper-wrapper > .swiper-slide"
        )
        if (!slides.length) return

        const fromLeft = section.dataset.sliderPosition === "left"
        const offset = fromLeft ? -120 : 120

        gsap.set(slides, { autoAlpha: 0, x: offset })

        const cardsContainer = section.querySelector(".card-slider") || section

        ScrollTrigger.create({
            trigger: cardsContainer,
            start: "center bottom",
            once: true,
            onEnter: () => {
                gsap.to(slides, {
                    autoAlpha: 1,
                    x: 0,
                    duration: 1,
                    ease: "expo.out",
                    stagger: 0.12,
                })
            },
        })
    })
}

export default init
